var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',_vm._g(_vm._b({ref:"ValidationProvider_ref",scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_vm._t("default",null,{"attrs":{
        'error-messages':
          (_vm.serverErrors && _vm.serverErrors[_vm.$attrs.errorName]) || errors,
      },"hasError":errors[0] || (_vm.serverErrors && _vm.serverErrors[_vm.$attrs.errorName])})]}}],null,true)},'ValidationProvider',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }